var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messagesExist)?_c('div',{staticClass:"message-area"},_vm._l((_vm.GET_MESSAGES_ELEMENTS),function(message){return _c('MessageComponent',{key:message.id,attrs:{"message":message,"currentUserId":_vm.currentUserId}})}),1):_c('p',[_vm._v(_vm._s(_vm.$t("message.empty_chat")))])
}
var staticRenderFns = []

export { render, staticRenderFns }